export default __webpack_public_path__ + "static/media/b418767a-243c-4ee6-b022-bedf3b1a8658.011a82ad.woff";